import Ripple from 'primevue/ripple'
import Tooltip from 'primevue/tooltip'
import { App } from 'vue'

import { detectAndShow } from './detect-element'
import { inifiteScroll } from './infinite-scroll'

export const registerDirectives = (app: App) => {
  inifiteScroll(app)
  detectAndShow(app)
  app.directive('tooltip', Tooltip)
  app.directive('ripple', Ripple)
}
